import { UPDATE_USER, GET_CONFIGURATION } from "./types";

export const updateUser = (value) => async (dispatch) => {
    await dispatch({
        type: UPDATE_USER,
        payload: value
    });
};

export const getConfiguration = (value) => async (dispatch) => {
    await dispatch({
        type: GET_CONFIGURATION,
        payload: value
    });
};